import { AssistentItem } from '../assistent_config';
import { IDs } from '../../../../helpers/IDs';
import { TriggerService } from '../../../../core/trigger/trigger_service';

export function getAssistentConfigWasser(data: any, triggerService: TriggerService, customCfg?: AssistentItem): AssistentItem {
    const eingabe_wasser = {
        gliederung: '3.',
        name: 'Wasser/Abwasser',
        dataName: 'Wasser',
        description: 'Dies ist das Formular zur Eingabe der Wasser/Abwasser-Daten.',
        type: 'EntityForm',
        addLabel: 'Neuen Wasser/Abwasser-Datensatz erfassen',
        entity: IDs.ENT_ENERGIEDATEN_WASSER,
        configFlag: 'inputWasser',
        customOnSaveDone: (entity: string, dataItem: any) => {
            triggerService.fire('reload', IDs.ENT_ENERGIEDATEN_WASSER);
        },
        ...(customCfg || {})
    };
    return eingabe_wasser;
}
